import { Map, fromJS } from 'immutable';

import * as types from './Types.js';

const initialState = Map({
  isLoading: false,
  logged: false
});

export default function keycloakReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_USER_ROLES:
    case types.GET_USER_ROLES_START:
      return state.set('isLoading', true);

    case types.GET_USER_ROLES_SUCCESS: {
      const reduceAccess = (map, role) => {
        map[role.name] = role;
        return map;
      };

      const access = action.payload.roles.reduce(reduceAccess, {});

      return state
        .setIn(['userAccess', 'roles'], fromJS(access))
        .set('isLoading', false)
        .set('logged', true);
    }
    default: {
      return state;
    }
  }
}
